import { useState, useEffect } from "react"
import { getAllCategoryOptions } from "helpers/productCategoryApi"

/**
 * Hook that loads all product categories and their options from the DB.
 * Uses the optimized getAllCategoryOptions (2 API calls instead of N+1).
 *
 * Returns a flat map keyed by category name:
 *   categories.Kasoma   → [{ id, name, value }, ...]
 *   categories.Position → [{ id, name }, ...]
 *   categories.Pomolo   → [{ id, name }, ...]
 *   categories.Model    → [{ id, name, value, description }, ...]
 */
export const useCategoryOptions = () => {
  const [categories, setCategories] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadAll()
  }, [])

  const loadAll = async () => {
    try {
      const allCategories = await getAllCategoryOptions()
      const result = {}

      for (const [categoryName, categoryData] of Object.entries(allCategories)) {
        result[categoryName] = categoryData.options.map((opt) => ({
          id: opt.id,
          name: opt.name,
          value: opt.value || opt.name,
          description: opt.description || "",
        }))
      }

      setCategories(result)
    } catch (err) {
      console.error("[useCategoryOptions] Failed to load:", err)
    } finally {
      setLoading(false)
    }
  }

  return { categories, loading }
}
